import * as React from "react";
const SvgFiRrDiscoBall = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-disco-ball_svg__a)">
      <path
        fill="#062147"
        d="M13 4.051V2h2a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2h2v2.051a10 10 0 1 0 2 0m3 11.619v-3.34c2.634.468 4 1.308 4 1.67s-1.366 1.2-4 1.67M4 14c0-.362 1.366-1.2 4-1.67v3.34C5.366 15.2 4 14.362 4 14m6-1.922a25.4 25.4 0 0 1 4 0v3.844a25.4 25.4 0 0 1-4 0zM12 6c.675.002 1.347.09 2 .263v3.812A27 27 0 0 0 12 10c-.665 0-1.336.026-2 .075V6.263A8 8 0 0 1 12 6m7.5 5.236A15 15 0 0 0 16 10.3V7.082a8.04 8.04 0 0 1 3.5 4.154M8 7.082V10.3a15 15 0 0 0-3.5.933A8.04 8.04 0 0 1 8 7.082m-3.5 9.682c1.124.453 2.3.767 3.5.936v3.221a8.04 8.04 0 0 1-3.5-4.157m5.5 4.973v-3.812c.664.049 1.335.075 2 .075s1.336-.026 2-.075v3.812c-1.31.35-2.69.35-4 0m6-.819V17.7a15 15 0 0 0 3.5-.933 8.04 8.04 0 0 1-3.5 4.151"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-disco-ball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiscoBall;
